import http from './http'

export default {
  findById: (id) => http.get(`/api/sectors/${id}`),

  getByParams: (params) => http.get('/api/sectors/', { params }),

  performance: () => http.get('/api/sector-performance/')
}
